import { useMutation } from "react-query";
import { apiClient } from "../utils/api-client";
import storage from "../utils/storage";
import { Modal } from "antd";
import { Notify } from "../components/notification";
import { useHistory } from "react-router-dom";

export const useQueryTransaction = (payload) => {
  const history = useHistory();
  const tokenExpired = () => {
    storage.clear();
    history.push("/login");
  };
  const token = storage.fetch("token");
  apiClient.defaults.headers.common["auth_token"] = token;
  return useMutation(async () => {
    const { data } = await apiClient
      .post(`/merchant/order/queryTrans`, payload)
      .catch(function (error) {
        // handle error
        Notify(
          "error",
          "Network Error!",
          "Please check your internet connection!",
          10
        );
      });
    if (data?.code === "900009") {
      Modal.error({
        title: "Session Timeout!",
        content: "Sorry, please login again to continue",
        onOk: () => {
          tokenExpired();
          Modal.destroyAll();
        },
      });
    } else {
      return data;
    }
  });
};

export const useTradeSummary = (payload) => {
  const history = useHistory();
  const tokenExpired = () => {
    storage.clear();
    history.push("/login");
  };
  const token = storage.fetch("token");
  apiClient.defaults.headers.common["auth_token"] = token;
  return useMutation(async () => {
    const { data } = await apiClient
      .post(`/merchant/order/queryTradeSummary`, payload)
      .catch(function (error) {
        // handle error
        Notify(
          "error",
          "Network Error!",
          "Please check your internet connection!",
          10
        );
      });
    if (data?.code === "900009") {
      Modal.error({
        title: "Session Timeout!",
        content: "Sorry, please login again to continue",
        onOk: () => {
          tokenExpired();
          Modal.destroyAll();
        },
      });
    } else {
      return data;
    }
  });
};

export const useSummaryGraph = (payload) => {
  const history = useHistory();
  const tokenExpired = () => {
    storage.clear();
    history.push("/login");
  };
  const token = storage.fetch("token");
  apiClient.defaults.headers.common["auth_token"] = token;
  return useMutation(async () => {
    const { data } = await apiClient
      .post(`/merchant/order/summaryGraph`, payload)
      .catch(function (error) {
        // handle error
        Notify(
          "error",
          "Network Error!",
          "Please check your internet connection!",
          10
        );
      });
    if (data?.code === "900009") {
      Modal.error({
        title: "Session Timeout!",
        content: "Sorry, please login again to continue",
        onOk: () => {
          tokenExpired();
          Modal.destroyAll();
        },
      });
    } else {
      return data;
    }
  });
};
